import React, { useState } from 'react'
import classes from './DutySlot.module.css'
import { Flex, Text, Tooltip, Spinner, useToast } from '@chakra-ui/react'
import { useGlobalStore } from '../../store/globalStore'
import { AddIcon } from '@chakra-ui/icons'
import { useAccessAPI } from '../../hooks/useAccessAPI'
import DutyService from '../../API/DutyService'
import { toastError, toastSuccess } from '../../utils/globalHelper'
import { useDutyStore } from '../../store/dutyStore'
import { transformDuty } from '../../utils/dutyHelper'

function DutySlot({slot}) {
    const toast = useToast()
    const user = useGlobalStore(state => state.user)
    const setDuty = useDutyStore(state => state.setDuty)
    const [isLoading, setIsLoading] = useState(false)
    const changeDutyUser = useAccessAPI(DutyService.changeDutyUser)

    const isEmptyCell = slot.user === null
    const isMyDuty = user.id === slot.user?.id
    const isReserve = slot.reserve

    const onSlot = async () => {
        if (isLoading)
            return

        setIsLoading(true)
        if (isEmptyCell) {
            const response = await changeDutyUser(slot?.slot_id, user?.id)
            if (response?.status === 200 && response?.data?.weeks?.length > 0) {
                // setDuty(response.data)
                setDuty(transformDuty(response.data))
                toast(toastSuccess('Вы успешно зписались на смену'))
            }
            else {
                toast(toastError('Не удалось записаться на смену', response?.data?.detail))
            }
        }
        else if (isMyDuty) {
            const response = await changeDutyUser(slot?.slot_id)
            if (response?.status === 200 && response?.data?.weeks?.length > 0) {
                // setDuty(response.data)
                setDuty(transformDuty(response.data))
                toast(toastSuccess('Вы успешно снялись со смены'))
            }
            else {
                toast(toastError('А всё, придётся работать', response?.data?.detail))
            }
        }
        setIsLoading(false)
    }

    const getCellHoverStyle = () => {
        if (isEmptyCell)
            return { borderColor: 'green', color: 'green' }
        if (isMyDuty)
            return { borderColor: 'orange' }
        return {}
    }

    const getCellStyle = () => {
        const hoverEmpty = { cursor: isLoading ? 'not-allowed' : 'pointer' }
        if (isEmptyCell)
            return isReserve ? {...hoverEmpty, background: 'var(--secondary-color)'} : {...hoverEmpty}
        if (isMyDuty)
            return {
                background: 'var(--chakra-colors-green-50)',
                cursor: isLoading ? 'not-allowed' : 'pointer'
            }
        else
            return {
                background: 'var(--chakra-colors-orange-50)',
                cursor: 'not-allowed'
            }
    }

    return (
        <Tooltip
            label={isMyDuty && 'Сняться со смены'}
            placement='right'
            hasArrow
        >
            <Flex
                className={classes.slot}
                style={getCellStyle()}
                _hover={getCellHoverStyle()}
                onClick={onSlot}
            >
                {isLoading
                ?
                <Spinner size='sm' />
                :
                <>
                {
                !isEmptyCell && 
                <Text whiteSpace='nowrap'>{slot.user?.name}</Text>
                }

                {isReserve && <Text>(резерв)</Text>}

                {slot?.user === null && <AddIcon />}
                </>
                }
            </Flex>
        </Tooltip>
    )
}

export default DutySlot
